import classNames from 'classnames';
import React, { PropsWithChildren, ReactNode } from 'react';
import { Table } from 'reactstrap';

interface ColumnConfig {
  className: string;
  width?: number;
}

interface CustomCell { 
  customCell: true; 
  content?: ReactNode; 
  className?: string; 
  colSpan?: number; 
}

type Cell = ReactNode | CustomCell;

interface CustomRow {
  customRow: true;
  cells: Array<Cell>;
  className?: string;
}

type Row = Array<Cell> | CustomRow

type IProps = PropsWithChildren<{
  headers?: Array<ReactNode>;
  rows: Array<Row>;
  columnConfig?: ColumnConfig[];
  tableProps?: any;
}>;

const isCustomRow = (row: Row): row is CustomRow =>
  !!(row as CustomRow)?.customRow;

const isCustomCell = (cell: Cell): cell is CustomCell =>
  !!(cell as CustomCell)?.customCell;


export default (props: IProps) => {
  const conf = props.columnConfig;
  let headers = null;
  if (props.headers) {
    headers = (
      <thead>
        <tr>
          {props.headers.map((h, i) => {
            return (
              <th key={i} className={conf?.[i]?.className}>
                {h}
              </th>
            );
          })}
        </tr>
      </thead>
    );
  }

  const { className, ...others } = props.tableProps || {}
  return (
    <Table striped className={classNames("mb-0", className)} {...others}>
      {headers}
      <tbody>
        {props.rows.map((row, i) => {
          if (!row) {
            return null;
          }
          
          const className = isCustomRow(row) ? row.className : undefined;
          const cells: Cell[] = isCustomRow(row) ? row.cells : row;

          return (
            <tr key={i} className={className}>
              {cells.map((cell, i) => {
                if (isCustomCell(cell)) {
                  return (
                    <td key={i} className={cell?.className} colSpan={cell?.colSpan}>
                      {cell?.content}
                    </td>
                  )
                }
                return (
                  <td key={i} className={conf?.[i]?.className} width={conf?.[i]?.width}>
                    {cell}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
